export const ASSEMBLY_PROVIDER_KEY = 'assemblyai';
export const ASSEMBLY_MODEL_NAME = 'assembly-universal-2';
export const ASSEMBLY_PROVIDER_MODEL = 'universal-2';
export const PROVIDER_RESPONSE_PHASE = 5;
export const SUCCESS_FINAL_PHASE = 9;
